import React, { useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';
import { useApiClient } from '../../ApiService/useApiClient';

const AgentDropdown = ({ value, onChange }) => {
  const [agents, setAgents] = useState([]);

  const api = useApiClient();

  useEffect(() => {
    const fetchAgents = async () => {
      try {
        const response = await api.get("HMCareStaff/stafflist/");
        const filteredAgents = response.data.filter(agent => agent.isAdmin === "0");
        setAgents(filteredAgents);
        //setAgents(response.data);

//console.log(response.data);

      } catch (error) {
        console.error('Error fetching agents:', error);
      }
    };
    fetchAgents();
  }, []);

  return (
    <Form.Select value={value} onChange={onChange}>
      <option value="">Select Staff</option>
      {agents.map(agent => (
        <option key={agent.agentId} value={agent.agentId}>
          {agent.name}
        </option>
      ))}
    </Form.Select>
  );
};

export default AgentDropdown;
